import React from 'react';
import { Input } from './ui/input';

export const MoneyInput = ({ value, onValueChange, placeholder, className, 'data-testid': testId, ...props }) => {
  const handleChange = (e) => {
    const raw = e.target.value.replace(/[^0-9.]/g, '');
    const parts = raw.split('.');
    const clean = parts.length > 2 ? parts[0] + '.' + parts.slice(1).join('') : raw;
    onValueChange?.(clean === '' ? '' : clean);
  };

  return (
    <div className="relative">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm font-medium">$</span>
      <Input
        {...props}
        data-testid={testId}
        className={`pl-7 ${className || ''}`}
        value={value === '' || value === null || value === undefined ? '' : value}
        inputMode="decimal"
        placeholder={placeholder || '0.00'}
        onChange={handleChange}
      />
    </div>
  );
};
